<div class="transaction-details-container">
  <div class="header">
    <span>Manage and monitor your domains. Track SSL certificates, subdomains, and certificate expiry status for all your added domains.</span>
    <div class="actions">
      <div class="search-input-container">
        <i class="fa-solid fa-magnifying-glass" style="opacity: 0.9; color: #289DD2;"></i>
        <input type="text" (input)="onSearchChange()" [(ngModel)]="searchQuery" placeholder="Search domains..."
          class="search-input" />
        <i *ngIf="searchQuery" class="fa-solid fa-xmark clear-search"
          style="opacity: 0.8; cursor: pointer; color: #289DD2; margin-left: 5px;"
          (click)="searchQuery = ''; onSearchChange()"></i>
      </div>
      <button type="button" class="filter-button" (click)="addNew()">
        <i class="fa-solid fa-plus" style="margin-right: 8px;"></i>
        <span>Add New</span>
      </button>
    </div>
  </div>

  <div class="table-container">
    <div *ngIf="isLoading" class="no-transactions-message">Loading domains...</div>

    <table *ngIf="!isLoading" class="transactions-table">
      <thead>
        <tr>
          <th>
            <div class="th-content">
              <i class="fa-solid fa-globe th-icon"></i>
              <span>Domain</span>
            </div>
          </th>
          <th>
            <div class="th-content">
              <i class="fa-solid fa-calendar-days th-icon"></i>
              <span>Added On</span>
            </div>
          </th>
          <th>
            <div class="th-content">
              <i class="fa-solid fa-gears th-icon"></i>
              <span>Actions</span>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="filteredDomains.length > 0; else noDomains">
          <tr *ngFor="let item of filteredDomains" class="clickable-row" (click)="viewSubDomains(item.domain || item.name)">
            <td style="font-weight: 500;">
              <i class="fa-solid fa-globe" style="color: #289dd2; margin-right: 8px; font-size: 13px;"></i>
              {{ item.domain || item.name }}
            </td>
            <td style="opacity: 0.9; font-size: 14px;">
              {{ (item.created_at || item.createdAt) | date: 'MMM dd, yyyy' }}
            </td>
            <td>
              <button class="action-button" (click)="$event.stopPropagation(); viewSubDomains(item.domain || item.name)">
                <i class="fa-solid fa-eye" style="margin-right: 5px;"></i>
                View Subdomains
              </button>
            </td>
          </tr>
        </ng-container>
        <ng-template #noDomains>
          <tr>
            <td colspan="3" class="no-transactions-message">{{ noDomainsMessage }}</td>
          </tr>
        </ng-template>
      </tbody>
    </table>
  </div>
</div>
